/**
 * SpotifyTrackRow — shared list item for search results + browse tabs.
 *
 * Used by `SpotifySearchPanel` and `SpotifyBrowsePanel`. Lives here (not
 * inline) because both panels render it and we want a single source of truth
 * for the row layout / hover affordance.
 */
import React from "react";
import { Play } from "lucide-react";

export default function SpotifyTrackRow({ item, kind, onPlay, testid }) {
  const subtitle =
    kind === "playlists"
      ? `${item.tracks_total || 0} tracks · ${item.owner || "—"}`
      : (item.artists || []).join(", ") || item.album || "";

  return (
    <button
      type="button"
      onClick={() => onPlay(item, kind === "playlists" ? "playlist" : "track")}
      className="group w-full flex items-center gap-3 p-2.5 hover:bg-white/10 text-left transition-colors"
      data-testid={testid}
    >
      {item.image ? (
        <img src={item.image} alt="" className="w-10 h-10 rounded-md object-cover shrink-0" />
      ) : (
        <div className="w-10 h-10 rounded-md bg-white/5 shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white truncate">{item.name}</div>
        <div className="text-xs text-white/40 truncate">{subtitle}</div>
      </div>
      <Play className="w-4 h-4 text-white/30 group-hover:text-[#1DB954] shrink-0 transition-colors" />
    </button>
  );
}
